/**
 * Render safety – production hardening.
 * This file must contain NO JSX. Pure helpers only.
 * GuardedRender/SafeRender (JSX) live in safeRender.tsx.
 */

export function safeArrayAt<T>(arr: T[] | null | undefined, index: number): T | undefined {
  if (arr == null || !Array.isArray(arr)) return undefined;
  if (arr.length === 0) return undefined;
  if (typeof index !== 'number' || index < 0 || index >= arr.length) return undefined;
  return arr[index];
}

export function clampIndex(index: number, length: number): number {
  if (length <= 0) return 0;
  if (index < 0) return 0;
  if (index >= length) return length - 1;
  return index;
}

export function isValidIndex(arr: unknown[] | null | undefined, index: number): boolean {
  if (arr == null || !Array.isArray(arr)) return false;
  if (arr.length === 0) return false;
  if (typeof index !== 'number' || index < 0 || index >= arr.length) return false;
  return true;
}
